import clsx from 'clsx'

export default function Progress({className}: {className?: string}) {
    return <i role='progressbar' className={clsx('pi pi-spinner pi-spin progress-icon', className)}/>
}
